import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { SocialPosterSummary } from '@/types/team-posts';

export function useTeamPosters() {
  return useQuery({
    queryKey: ['team-posters'],
    queryFn: async () => {
      const { data, error } = await (supabase as any)
        .from('v_social_category_summary')
        .select('profile_name, category, unique_engagers, top_account_engagers')
        .gt('unique_engagers', 0)
        .order('unique_engagers', { ascending: false });
      
      if (error) throw error;
      return data as SocialPosterSummary[];
    }
  });
}
